import SessionService from './services/SessionService'

const getPartnerFriendlyName = () => {
    let partnerLogged = SessionService.getPartnerLogged();
    if(partnerLogged!=null){
        return partnerLogged.friendlyName;
    }
}

export const getAudiencePrefix = branded => {
    let prefix = ''
    /*if (!branded) {
        prefix = 'Audiencerate: Unbranded Data > '
    } else {
    */
    prefix = 'Audiencerate: Branded Data > ' + getPartnerFriendlyName() + ' > '
    //}
    return prefix
}
